import { Container } from '@pixi/react'
import { memo, useEffect, useMemo, useRef } from 'react'
import { Container as PixiContainer } from 'pixi.js'
import { spinService } from '../domain/game'
import { SlotSymbol } from './Symbol'
import { gameConfig } from '../config'
import { defaultTableList, useGameStore } from '../domain/game/store/GameStore'
import { FeatureToggleV2Type, FixedContainerV2, Loading, useFeatureToggleV2 } from '@slot-nx/core'
import { Blind } from './Blind'
import { tableService } from '../domain/table/tableService'
import { UpperReels, UpperReels2 } from './UpperReels'
import { spinEvent } from '../domain/spin/SpinUtil'

const REEL_COUNT = 6
const REEL_WIDTH = gameConfig.nodeWidth
const CONTAINER_WIDTH = REEL_WIDTH * REEL_COUNT // 918
const x = 80

export const Slot = memo(() => {
  const reelRefs = useRef<PixiContainer[]>([])
  const reelsContainerRef = useRef<PixiContainer>(null)
  const slotContainerRef = useRef<PixiContainer>(null)
  const isShowSpinLoading = useGameStore(x => x.isShowSpinLoading)
  const enableReelTableClickForSpin = useFeatureToggleV2(FeatureToggleV2Type.enableReelTableClickForSpin)
  const y = 670
  const Reels = useMemo(() => {
    return Array.from({ length: REEL_COUNT }, (_, i) => (
      <Container
        name={`Reel_${i}`}
        x={i * REEL_WIDTH}
        y={0}
        key={i}
        ref={(el) => { if (el) reelRefs.current[i] = el as PixiContainer }}
      >
        {defaultTableList[i].map((tile, j) => (
          <SlotSymbol
            key={`${i}-${j}`}
            x={0}
            y={j * gameConfig.nodeHeight}
            data={tile}
          />
        ))}
      </Container>
    ))
  }, [])

  useEffect(() => {
    spinService.initReels(reelRefs.current)
    if (reelsContainerRef.current) {
      spinService.setReelsContainer(reelsContainerRef.current)
    }
    if (slotContainerRef.current) {
      tableService.setSlotContainer(slotContainerRef.current as PixiContainer)
    }
    tableService.generateUpperReelsNode()
  }, [])

  return (
    <Container>
      <FixedContainerV2
        name="Slot"
        ref={slotContainerRef}
        width={CONTAINER_WIDTH}
        height={gameConfig.containerHegiht}
        position={[x, y]}
        eventMode={enableReelTableClickForSpin ? 'static' : 'auto'}
        onpointertap={enableReelTableClickForSpin ? spinEvent : null}
      >
        {isShowSpinLoading ? <Loading x={CONTAINER_WIDTH / 2} y={gameConfig.containerHegiht / 2} width={100} height={100} /> : null}
        <Container ref={reelsContainerRef}>
          {Reels}
        </Container>
        {Array.from({ length: REEL_COUNT }, (_, i) => (
          <Blind
            key={`blind_${i}`}
            name={`blind_${i}`}
            x={i * REEL_WIDTH}
            y={0}
          />
        ))}

      </FixedContainerV2>
      <UpperReels x={x + 80} y={y} />
      <UpperReels2 x={x + 80} y={y} />
    </Container>
  )
})
